var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSubscriptionPlanImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 150,
    viewBox: "0 0 214 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8316_57831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.317 16.0829L167.532 33.2336C173.866 34.2078 179 38.6565 179 43.1632V73.2674C179 77.7741 173.866 82.2163 167.532 83.1825L48.1665 95.9186C41.8331 96.7316 35 91.3884 35 82.9379V29.0505C35 20.6 40.9837 15.2626 47.317 16.0829Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9136 40.6596L162.977 45.9057C164.521 46.0191 165.773 47.0798 165.773 48.2748C165.773 49.4697 164.521 50.379 162.977 50.3059L87.9136 46.9201C86.3694 46.854 85.1176 45.3842 85.1176 43.6373C85.1176 41.8903 86.3694 40.5571 87.9136 40.6596Z",
    fill: "#1B3554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9136 52.071L141.724 53.3824C143.268 53.4214 144.52 54.5443 144.52 55.8904C144.52 57.2365 143.268 58.3278 141.724 58.3279L87.9136 58.3315C86.3694 58.3316 85.1176 56.9155 85.1176 55.1686C85.1176 53.4216 86.3694 52.0348 87.9136 52.071Z",
    fill: "#1B3554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9136 69.1891L105.386 68.4656C106.931 68.4008 108.182 69.6412 108.182 71.2363C108.182 72.8314 106.931 74.2074 105.386 74.3094L87.9136 75.4497C86.3694 75.5491 85.1176 74.2134 85.1176 72.4665C85.1176 70.7195 86.3694 69.2523 87.9136 69.1891Z",
    fill: "#1B3554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6654 65.8097C70.9075 65.6352 77.5891 58.5958 77.5891 50.0887C77.5891 41.5816 70.9075 34.2129 62.6654 33.6365C54.4232 33.067 47.7416 40.1119 47.7416 49.3654C47.7416 58.6188 54.4232 65.9821 62.6654 65.8097Z",
    fill: "#8DAA6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2729 55.6737C60.5569 55.9847 60.928 56.1411 61.2999 56.1433C61.6718 56.1456 62.0429 55.9945 62.3269 55.6889L69.5899 48.0425C70.1572 47.4589 70.1572 46.4856 69.5899 45.8647C69.0227 45.2418 68.1032 45.207 67.5359 45.7905L61.2999 52.3358L57.969 48.6313C57.4018 47.9936 56.4823 47.9675 55.9151 48.5764C55.3478 49.1873 55.3478 50.202 55.9151 50.8397L60.2729 55.6737Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8316_57831",
    x: 0,
    y: 0,
    width: 214,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.226735 0 0 0 0 0.437054 0 0 0 0 0.687819 0 0 0 0.189057 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8316_57831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8316_57831",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubscriptionPlanImage);
export default __webpack_public_path__ + "static/media/noSubscriptionPlanImage.701e07013ba0c13309578a9bf1a71b4c.svg";
export { ForwardRef as ReactComponent };